// 验证数字（只能输入整数）
export const CheckNumber = function (rule, value, callback) {
  if(!value) {
    callback();
  }else{
    if (/[^\d]/g.test(value)) {
        callback(new Error("请输入正确的数字"));
    } else {
        callback();
    }
  }
};
// 验证数字（只能输入整数或小数）
export const CheckPriceOrDistance = function (rule, value, callback) {
  if(!value) {
    callback();
  }else {
  
    if (!/^((0{1}\.\d+)|([1-9]\d*\.{1}\d+)|([1-9]+\d*))$/.test(value)) {
        callback(new Error("请输入正确的整数或小数"));
    } else {
        callback();
    }
  }
};
// 验证数字长度
export const CheckNumberLength = function (rule, value, callback) {
  if(!value) {
    callback();
  }else {
    if (value.length > 10) {
        callback(new Error("请输入10个字符以内"));
    } else {
        callback();
    }
  }
};
// 验证备注长度
export const CheckRemarkLength = function (rule, value, callback) {
  if(!value) {
    callback();
  }else {
  if(!/^\S*$/.test(value)) {
    callback(new Error("请勿输入空格"))
  }
    if (value.length > 100) {
        callback(new Error("请输入100个字符以内"));
    } else {
        callback();
    }
  }
};
// 验证备注长度
export const CheckComparyNameLength = function (rule, value, callback) {
  if(!value) {
    callback();
  }else {
  if(!/^\S*$/.test(value)) {
    callback(new Error("请勿输入空格"))
  }
  if (value.length > 20) {
      callback(new Error("请输入20个字符以内"));
  } else {
      callback();
  }
}
};
// 验证手机号
export const CheckPhone = function (rule, value, callback) {
  if(!value) {
    callback();
  }else {
  if(!/^\S*$/.test(value)) {
    callback(new Error("请勿输入空格"))
  }
    if (/^(([0\+]\d{2,3}-)?(0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$/.test(value) || /^1[3456789][0-9]\d{8}$/.test(value)) {
      callback();
    } else {
      callback(new Error("格式不正确"));
    }
  }
};

// 验证是否数值类型
export function isDecimal(rule, value, callback) {
    setTimeout(() => {
      if(!value) {
        callback();
      }else {
        if (value === "" || value === null || value === undefined) {
            callback(new Error('必须为非负数最多三位小数'));
        } else {
            const re = /^(([0-9][0-9]*)|(([0]\.\d{1,3}|[1-9][0-9]*\.\d{1,3})))$/;
            const rsCheck = re.test(value);
            if (!rsCheck) {
                callback(new Error('必须为非负数最多三位小数'));
            } else {
                callback();
            }
        }}
    }, 0);
};

//正整数验证
export function validatorIntNum(rule, value, callback) {
    if (value !== "" && value !== undefined && value!==null) {
        if (!/^[0-9]*$/.test(value)) {
            callback(new Error("请填写正整数"));
        } else {
            callback();
        }
    } else {
        callback();
    }
};

// 验证邮箱格式
export const CheckEmail = function (rule, value, callback) {
  if(!value) {
    callback();
  }else {
  if(!/^\S*$/.test(value)) {
    callback(new Error("请勿输入空格"))
  }
    if (!/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value)) {
        callback(new Error("邮箱格式不正确"));
    } else {
        callback();
    }
  }
};

// 验证是否数值类型
export function isNumber6Decimal3(rule, value, callback) {
    setTimeout(() => {
      if(!value) {
        callback();
      }else {
        if (value === "" || value === null || value === undefined) {
            callback();
        } else {
            const re = /^\d{1,6}(\.\d{1,3})?$/;
            const rsCheck = re.test(value);
            if (!rsCheck) {
                callback(new Error('必须为非负数最多六位整数三位小数'));
            } else {
                callback();
            }
        }
      }
    }, 0);
};

//IP验证
export function validatorIP(rule, value, callback) {
  if(!value) {
    callback();
  }else {
  if(!/^\S*$/.test(value)) {
    callback(new Error("请勿输入空格"))
  }
    if (
        !/^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/.test(
            value
        )
    ) {
        callback(new Error("IP格式不正确"));
    } else {
        callback();
    }
  }
};

//身份证验证
export function validatorIdCard(rule, value, callback) {
  if(!value) {
    callback();
  }else {
  if(!/^\S*$/.test(value)) {
    callback(new Error("请勿输入空格"))
  }
  if (
      !/(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/.test(
          value
      )
  ) {
      callback(new Error("请输入正确的身份证号"));
  } else {
      callback();
  }
}
};
// 验证车牌号
export const CheckVehicleNo = function(rule, value, callback) {
 
  if (!value) {
    callback();
  } else if (
    !/^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]{1,2}))$/.test(
      value
    )||!/^\S*$/.test(value)
  ) {
    callback(new Error("请输入正确的车牌号"));
  } else {
    callback();
  }
};

// 验证长度为17的字母或数字组成（只能输入字母或数字）
export const CheckVehicleIdentificationNo = function(rule, value, callback) {
  if(!value) {
    callback();
  }else {
  if(!/^\S*$/.test(value)) {
    callback(new Error("请勿输入空格"))
  }
  if (/^[a-zA-Z0-9]{8,16}$/.test(value)) {
    callback();
  } else {
    callback(new Error("请输入8-16位数字或字母"));
  }
}
};

export const CheckIsEmpty = function(rule,value,callback) {
  if(!value) {
    callback();
  }else {
  if(!/^\S*$/.test(value)) {
    callback("请勿输入空格");
  }else {
    callback();
  }
}
};

export const CheckCreditUnicode = function(rule,value,callback) {
  if(!value) {
    callback();
  }else {
  if(!/^\S*$/.test(value)) {
    callback(new Error("请勿输入空格"))
  }
  if (/^[a-zA-Z0-9]{18}$/.test(value)) {
    callback();
  } else {
    callback(new Error("请输入18位数字或字母"));
  }
}
}